// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: #121212;
  color: #f1f1f1;
}

.mwg_effect022 {
  width: 100%;
  max-width: calc(100 * var(--vw));
  overflow-x: hidden;
  overflow-y: visible;
}

.mwg_effect022 .pin-height {
  height: 400vh;
}

.mwg_effect022 .container {
  height: 100vh;
  width: 100%;
  max-width: calc(100 * var(--vw));
  box-sizing: border-box;
}

.mwg_effect022 .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: calc(1 * var(--vw));
  padding-top: calc(5 * var(--vw));
  padding-right: calc(10 * var(--vw));
  padding-bottom: calc(5 * var(--vw));
  padding-left: calc(2.5 * var(--vw));
  border-bottom: 1px dashed rgb(73, 73, 73);
  width: 100%;
  max-width: calc(100 * var(--vw));
  box-sizing: border-box;
}

.mwg_effect022 .top p {
  font: 500 normal calc(6 * var(--vw))/0.9 "Satoshi", sans-serif;
  letter-spacing: -0.05em;
}

.mwg_effect022 .top img.logo {
  width: calc(18 * var(--vw));
  height: auto;
  object-fit: contain;
}

.mwg_effect022 .paragraphs {
  display: flex;
  align-items: center;
  padding: calc(5 * var(--vw)) calc(2.5 * var(--vw));
  column-gap: calc(2.5 * var(--vw));
  font: 500 normal calc(1.9 * var(--vw))/0.9 "Satoshi", sans-serif;
  letter-spacing: 0.015em;
  border-bottom: 1px dashed rgb(73, 73, 73);
  width: 100%;
  max-width: calc(100 * var(--vw));
  box-sizing: border-box;
}

.mwg_effect022 .word {
  position: relative;
  overflow: hidden;
  display: inline-block;
  margin: -0.14em 0; /* Depends on the font used */
}

.mwg_effect022 .word span {
  display: block;
  padding: 0.14em 0; /* Depends on the font used */
}

.mwg_effect022 .word.feature-highlight span {
  color: #CCFF00;
  font-weight: 700;
}

.mwg_effect022 .feature-highlight {
  color: #CCFF00;
  font-weight: 700;
}

.mwg_effect022 .paragraph:not(:first-child) .word span {
  transform: translate(0, 100%);
}

/* Slideshow container styles */
.mwg_effect022 .container {
  position: relative;
}

.mwg_effect022 .features-content,
.mwg_effect022 .form-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  will-change: opacity, transform;
}

.mwg_effect022 .features-content {
  opacity: 1;
  z-index: 2;
}

.mwg_effect022 .form-content {
  opacity: 0;
  z-index: 1;
  overflow: hidden;
}

.mwg_effect022 .form-content .form-section {
  height: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* ==================== MEDIA QUERIES ==================== */

/* Mobile (max-width: 768px) */
@media (max-width: 768px) {
  .mwg_effect022 {
    background: #121212;
    color: #f1f1f1;
  }

  .mwg_effect022 .pin-height {
    height: auto !important;
    min-height: auto;
  }

  .mwg_effect022 .container {
    height: auto !important;
    min-height: auto;
    position: relative !important;
  }

  .mwg_effect022 .features-content,
  .mwg_effect022 .form-content {
    position: relative !important;
    height: auto !important;
  }

  .mwg_effect022 .form-content {
    opacity: 1 !important;
    margin-top: 50px;
  }

  .mwg_effect022 .top {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: flex-start !important;
    padding: 30px calc(4 * var(--vw)) !important;
    gap: 12px !important;
    border-bottom: 1px dashed rgb(73, 73, 73) !important;
  }

  .mwg_effect022 .top p {
    font-size: 32px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    letter-spacing: -0.03em !important;
    margin: 0 !important;
    flex: 1 1 !important;
  }

  .mwg_effect022 .top img.logo {
    width: 128px !important;
    height: auto !important;
    object-fit: contain !important;
    flex-shrink: 0 !important;
    margin-left: 0 !important;
  }

  .mwg_effect022 .paragraphs {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    padding: 30px calc(4 * var(--vw)) !important;
    gap: 25px !important;
    font-size: 15px !important;
    font-weight: 400 !important;
    line-height: 1.6 !important;
    letter-spacing: 0.02em !important;
    border-bottom: 1px dashed rgb(73, 73, 73) !important;
  }

  .mwg_effect022 .paragraph {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Mobile Horizontal Slide */
  .paragraphs-mobile {
    position: relative;
    width: 100%;
    padding: 30px calc(4 * var(--vw)) !important;
    border-bottom: 1px dashed rgb(73, 73, 73) !important;
    box-sizing: border-box;
  }

  .paragraphs-slider {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-bottom: 70px; /* Space for button and indicator */
    min-height: 120px; /* Minimum height for content */
  }

  .paragraphs-track {
    display: flex;
    width: 100%;
    will-change: transform;
  }

  .paragraph-slide {
    min-width: 100%;
    width: 100%;
    flex-shrink: 0;
    box-sizing: border-box;
  }

  .paragraph-slide .paragraph {
    font-size: 15px !important;
    font-weight: 400 !important;
    line-height: 1.6 !important;
    letter-spacing: 0.02em !important;
    margin: 0 !important;
    padding: 0 !important;
    color: #f1f1f1 !important;
  }

  .paragraphs-next-btn {
    position: absolute;
    right: calc(4 * var(--vw));
    bottom: 30px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #4a4a4a;
    border: none;
    color: #ffffff;
    font-size: 24px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;
    box-shadow: 0 4px 12px rgba(47, 47, 47, 0.3);
  }

  .paragraphs-next-btn:hover {
    background: #CCFF00;
    color: #121212;
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(204, 255, 0, 0.4);
  }

  .paragraphs-next-btn:active {
    transform: scale(0.95);
  }

  .paragraphs-indicator {
    position: absolute;
    bottom: 30px;
    left: calc(4 * var(--vw));
    font-size: 14px;
    font-weight: 400;
    color: rgba(241, 241, 241, 0.6);
    z-index: 10;
  }

  .mwg_effect022 .word {
    position: relative !important;
    overflow: visible !important;
    display: inline !important;
    margin: 0 !important;
  }

  .mwg_effect022 .word span {
    display: inline !important;
    padding: 0 !important;
    transform: translateY(0) !important;
  }

  .mwg_effect022 .paragraph:not(:first-child) .word span {
    transform: translateY(0) !important;
  }
}

/* Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
  .mwg_effect022 .top {
    padding: 25px calc(4 * var(--vw)) !important;
    gap: 15px !important;
  }

  .mwg_effect022 .top p {
    font-size: 28px !important;
  }

  .mwg_effect022 .top img.logo {
    width: 112px !important;
    margin-left: 0 !important;
  }

  .mwg_effect022 .paragraphs {
    padding: 25px calc(4 * var(--vw)) !important;
    gap: 20px !important;
    font-size: 14px !important;
    letter-spacing: 0.02em !important;
  }

  .paragraphs-mobile {
    padding: 25px calc(4 * var(--vw)) !important;
  }

  .paragraph-slide .paragraph {
    font-size: 14px !important;
    letter-spacing: 0.02em !important;
  }

  .paragraphs-next-btn {
    width: 44px !important;
    height: 44px !important;
    font-size: 20px !important;
    right: calc(4 * var(--vw)) !important;
    bottom: 25px !important;
  }

  .paragraphs-indicator {
    bottom: 25px !important;
    left: calc(4 * var(--vw)) !important;
    font-size: 13px !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/component/features/features.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,yCAAyC;EACzC,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8DAA8D;EAC9D,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,iCAAiC;EACjC,gEAAgE;EAChE,uBAAuB;EACvB,yCAAyC;EACzC,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA;EACE,cAAc;EACd,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,4DAA4D;;AAE5D,8BAA8B;AAC9B;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;;IAEE,6BAA6B;IAC7B,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,8BAA8B;IAC9B,sCAAsC;IACtC,4CAA4C;IAC5C,oBAAoB;IACpB,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;IAClC,oBAAoB;IACpB,oBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,8BAA8B;IAC9B,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,oDAAoD;EACtD;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,oDAAoD;IACpD,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB,EAAE,mCAAmC;IACxD,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,4CAA4C;IAC5C,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,4CAA4C;IAC5C,oBAAoB;IACpB,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,oCAAoC;IACpC,0BAA0B;EAC5B;AACF","sourcesContent":["body {\n  background: #121212;\n  color: #f1f1f1;\n}\n\n.mwg_effect022 {\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n.mwg_effect022 .pin-height {\n  height: 400vh;\n}\n\n.mwg_effect022 .container {\n  height: 100vh;\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  box-sizing: border-box;\n}\n\n.mwg_effect022 .top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: calc(1 * var(--vw));\n  padding-top: calc(5 * var(--vw));\n  padding-right: calc(10 * var(--vw));\n  padding-bottom: calc(5 * var(--vw));\n  padding-left: calc(2.5 * var(--vw));\n  border-bottom: 1px dashed rgb(73, 73, 73);\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  box-sizing: border-box;\n}\n\n.mwg_effect022 .top p {\n  font: 500 normal calc(6 * var(--vw))/0.9 \"Satoshi\", sans-serif;\n  letter-spacing: -0.05em;\n}\n\n.mwg_effect022 .top img.logo {\n  width: calc(18 * var(--vw));\n  height: auto;\n  object-fit: contain;\n}\n\n.mwg_effect022 .paragraphs {\n  display: flex;\n  align-items: center;\n  padding: calc(5 * var(--vw)) calc(2.5 * var(--vw));\n  column-gap: calc(2.5 * var(--vw));\n  font: 500 normal calc(1.9 * var(--vw))/0.9 \"Satoshi\", sans-serif;\n  letter-spacing: 0.015em;\n  border-bottom: 1px dashed rgb(73, 73, 73);\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  box-sizing: border-box;\n}\n\n.mwg_effect022 .word {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  margin: -0.14em 0; /* Depends on the font used */\n}\n\n.mwg_effect022 .word span {\n  display: block;\n  padding: 0.14em 0; /* Depends on the font used */\n}\n\n.mwg_effect022 .word.feature-highlight span {\n  color: #CCFF00;\n  font-weight: 700;\n}\n\n.mwg_effect022 .feature-highlight {\n  color: #CCFF00;\n  font-weight: 700;\n}\n\n.mwg_effect022 .paragraph:not(:first-child) .word span {\n  transform: translate(0, 100%);\n}\n\n/* Slideshow container styles */\n.mwg_effect022 .container {\n  position: relative;\n}\n\n.mwg_effect022 .features-content,\n.mwg_effect022 .form-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  will-change: opacity, transform;\n}\n\n.mwg_effect022 .features-content {\n  opacity: 1;\n  z-index: 2;\n}\n\n.mwg_effect022 .form-content {\n  opacity: 0;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.mwg_effect022 .form-content .form-section {\n  height: 100%;\n  max-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/* ==================== MEDIA QUERIES ==================== */\n\n/* Mobile (max-width: 768px) */\n@media (max-width: 768px) {\n  .mwg_effect022 {\n    background: #121212;\n    color: #f1f1f1;\n  }\n\n  .mwg_effect022 .pin-height {\n    height: auto !important;\n    min-height: auto;\n  }\n\n  .mwg_effect022 .container {\n    height: auto !important;\n    min-height: auto;\n    position: relative !important;\n  }\n\n  .mwg_effect022 .features-content,\n  .mwg_effect022 .form-content {\n    position: relative !important;\n    height: auto !important;\n  }\n\n  .mwg_effect022 .form-content {\n    opacity: 1 !important;\n    margin-top: 50px;\n  }\n\n  .mwg_effect022 .top {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center !important;\n    justify-content: flex-start !important;\n    padding: 30px calc(4 * var(--vw)) !important;\n    gap: 12px !important;\n    border-bottom: 1px dashed rgb(73, 73, 73) !important;\n  }\n\n  .mwg_effect022 .top p {\n    font-size: 32px !important;\n    font-weight: 600 !important;\n    line-height: 1.2 !important;\n    letter-spacing: -0.03em !important;\n    margin: 0 !important;\n    flex: 1 !important;\n  }\n\n  .mwg_effect022 .top img.logo {\n    width: 128px !important;\n    height: auto !important;\n    object-fit: contain !important;\n    flex-shrink: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mwg_effect022 .paragraphs {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    padding: 30px calc(4 * var(--vw)) !important;\n    gap: 25px !important;\n    font-size: 15px !important;\n    font-weight: 400 !important;\n    line-height: 1.6 !important;\n    letter-spacing: 0.02em !important;\n    border-bottom: 1px dashed rgb(73, 73, 73) !important;\n  }\n\n  .mwg_effect022 .paragraph {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  /* Mobile Horizontal Slide */\n  .paragraphs-mobile {\n    position: relative;\n    width: 100%;\n    padding: 30px calc(4 * var(--vw)) !important;\n    border-bottom: 1px dashed rgb(73, 73, 73) !important;\n    box-sizing: border-box;\n  }\n\n  .paragraphs-slider {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    margin-bottom: 70px; /* Space for button and indicator */\n    min-height: 120px; /* Minimum height for content */\n  }\n\n  .paragraphs-track {\n    display: flex;\n    width: 100%;\n    will-change: transform;\n  }\n\n  .paragraph-slide {\n    min-width: 100%;\n    width: 100%;\n    flex-shrink: 0;\n    box-sizing: border-box;\n  }\n\n  .paragraph-slide .paragraph {\n    font-size: 15px !important;\n    font-weight: 400 !important;\n    line-height: 1.6 !important;\n    letter-spacing: 0.02em !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    color: #f1f1f1 !important;\n  }\n\n  .paragraphs-next-btn {\n    position: absolute;\n    right: calc(4 * var(--vw));\n    bottom: 30px;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: #4a4a4a;\n    border: none;\n    color: #ffffff;\n    font-size: 24px;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    z-index: 10;\n    box-shadow: 0 4px 12px rgba(47, 47, 47, 0.3);\n  }\n\n  .paragraphs-next-btn:hover {\n    background: #CCFF00;\n    color: #121212;\n    transform: scale(1.1);\n    box-shadow: 0 6px 16px rgba(204, 255, 0, 0.4);\n  }\n\n  .paragraphs-next-btn:active {\n    transform: scale(0.95);\n  }\n\n  .paragraphs-indicator {\n    position: absolute;\n    bottom: 30px;\n    left: calc(4 * var(--vw));\n    font-size: 14px;\n    font-weight: 400;\n    color: rgba(241, 241, 241, 0.6);\n    z-index: 10;\n  }\n\n  .mwg_effect022 .word {\n    position: relative !important;\n    overflow: visible !important;\n    display: inline !important;\n    margin: 0 !important;\n  }\n\n  .mwg_effect022 .word span {\n    display: inline !important;\n    padding: 0 !important;\n    transform: translateY(0) !important;\n  }\n\n  .mwg_effect022 .paragraph:not(:first-child) .word span {\n    transform: translateY(0) !important;\n  }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media (max-width: 480px) {\n  .mwg_effect022 .top {\n    padding: 25px calc(4 * var(--vw)) !important;\n    gap: 15px !important;\n  }\n\n  .mwg_effect022 .top p {\n    font-size: 28px !important;\n  }\n\n  .mwg_effect022 .top img.logo {\n    width: 112px !important;\n    margin-left: 0 !important;\n  }\n\n  .mwg_effect022 .paragraphs {\n    padding: 25px calc(4 * var(--vw)) !important;\n    gap: 20px !important;\n    font-size: 14px !important;\n    letter-spacing: 0.02em !important;\n  }\n\n  .paragraphs-mobile {\n    padding: 25px calc(4 * var(--vw)) !important;\n  }\n\n  .paragraph-slide .paragraph {\n    font-size: 14px !important;\n    letter-spacing: 0.02em !important;\n  }\n\n  .paragraphs-next-btn {\n    width: 44px !important;\n    height: 44px !important;\n    font-size: 20px !important;\n    right: calc(4 * var(--vw)) !important;\n    bottom: 25px !important;\n  }\n\n  .paragraphs-indicator {\n    bottom: 25px !important;\n    left: calc(4 * var(--vw)) !important;\n    font-size: 13px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
